import { Metamodel } from 'app/model/base/model';
import { BlobTypeStoreReadSettings } from './blob-type-store-read-settings';
import { FileServerLinkedService } from 'app/model/linkedservice/file-server.linkedservice';

import { IAttribute, IModel, IViolation } from 'app/model/base/annotation';
import { FilePathMode } from 'app/registries/consts/metadata-consts';
import { stringIsNullOrEmpty, format } from 'app/shared/utils/string.util';
import { StoreReadSettings } from './store-read-settings';

@Metamodel.model({
    name: 'FileServerReadSettings',
    display: [],
    tags: {
        linkedServiceModel: Metamodel.modelFor(FileServerLinkedService)
    }
})

export class FileServerStoreReadSettings extends BlobTypeStoreReadSettings {
    public static readonly MODEL: IModel;
    public static readonly FILE_FILTER: IAttribute;

    public supportedFilePathMode = [
        FilePathMode.DATASET,
        FilePathMode.FILEFILTER,
        FilePathMode.WILDCARD,
        FilePathMode.LIST
    ];

    @Metamodel.attribute({
        display: stringResources.ModelName_FileFilter,
        association: 'FILE_FILTER',
        templatable: true,
        constraint: {
            validator: FileServerStoreReadSettings.validateFileFilter
        }

    })
    public fileFilter?: string;

    private static async validateFileFilter(storeSettings: FileServerStoreReadSettings): Promise<IViolation[] | undefined> {
        if (storeSettings.filePathMode === FilePathMode.FILEFILTER && stringIsNullOrEmpty(storeSettings.fileFilter)
            && stringIsNullOrEmpty(FileServerStoreReadSettings.FILE_FILTER.templateValue(storeSettings))) {
            return [{
                context: storeSettings.fileFilter,
                message: () => format(stringResources.ValidationError_EmptyFilePathTemplate, stringResources.ModelName_FileFilter, stringResources.ModelName_FileFilter)
            }];
        }
        return undefined;
    }

    public recoverPropFromPrevOne(prevStoreSettings: StoreReadSettings): void {
        super.recoverPropFromPrevOne(prevStoreSettings);
        this.updateModelValue('fileFilter', this, prevStoreSettings);
    }
}
